<template>
    <div class="user-modal-body">
        <h3 class="text-center mb-4">{{name}}</h3>

        <app-establishment-search-section v-if="id"
                                          :key="'s' + id"
                                          :data-id="id"></app-establishment-search-section>

        <app-establishment-bind-section v-if="id"
                                        :key="'b' + id"
                                        :data-id="id"></app-establishment-bind-section>

    </div>
</template>

<script>
    import EventBus from '@packages/event-bus'
    import AppEstablishmentSearchSection from './sections/EstablishmentSearchSection'
    import AppEstablishmentBindSection from './sections/EstablishmentBindSection'

    export default {
        components: {
            AppEstablishmentSearchSection,
            AppEstablishmentBindSection,
        },

        data() {
            return {
                id: null,
                name: null,
            }
        },

        methods: {
            reset({entity, user}) {
                this.id = user.id
                this.name = user.general.name
                this.checks = user.checks
                this.entity = entity
            },
        },

        mounted() {
            EventBus.$on('RESET_USER_MODAL', this.reset)
        },

        beforeDestroy() {
            EventBus.$off('RESET_USER_MODAL', this.reset)
        },
    }
</script>

<style lang="scss" scoped>
    .user-modal-body {
        padding: 30px 50px;
    }
</style>
